import { render, staticRenderFns } from "./household_in_distance.vue?vue&type=template&id=3757c5a6"
import script from "./household_in_distance.vue?vue&type=script&lang=js"
export * from "./household_in_distance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports